import React from 'react';
import './App.css';
import Orders from './components/Orders';
import Login from './components/Login';
import { AuthProvider, useAuth } from './context/AuthContext';

function ProtectedAdmin() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Orders /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <ProtectedAdmin />
      </div>
    </AuthProvider>
  );
}

export default App;
